import Vue from 'vue';
import {
  Link,
  Pagination,
  Dialog,
  Autocomplete,
  Input,
  Radio,
  RadioButton,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Select,
  Option,
  Button,
  Table,
  TableColumn,
  DatePicker,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Icon,
  Row,
  Col,
  Scrollbar,
  Loading,
  MessageBox,
  Message,
  Transfer,
  Switch,
  Tooltip,
  Upload,
  Progress,
  Popover,
  Carousel,
  CarouselItem,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Tree,
  ColorPicker
} from 'element-ui';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.use(Link);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Input);
Vue.use(Radio);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Scrollbar);
Vue.use(Transfer);
Vue.use(Upload);
Vue.use(Switch);
Vue.use(Tooltip);
Vue.use(Progress);
Vue.use(Popover);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Submenu);
Vue.use(Tree);
Vue.use(ColorPicker)
Vue.use(Loading.directive);
Vue.prototype.$Loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
